import { WhatsappProvider } from "V2.0/HomePages/Integrations/Communications/Whatsapp/useWhatsapp";

import MetaTemplateForm from "./MetaTemplateForm";
import MCubeEngageTemplateForm from "./MCubeEngageTemplateForm";

export default WhatsappTemplateForm;

const WhatsappProviderTemplateFormRegistry = {
  [WhatsappProvider.META]: MetaTemplateForm,
  [WhatsappProvider.MCUBE_ENGAGE]: MCubeEngageTemplateForm,
};

function WhatsappTemplateForm(props) {
  const {
    errors,
    formState,
    workspaceId,
    updateFormState,
    activeWhatsappProvider,
    evolutionConfiguration
  } = props;

  const WhatsappProviderTemplateForm =
    WhatsappProviderTemplateFormRegistry[activeWhatsappProvider] ??
    WhatsappProviderTemplateFormRegistry[WhatsappProvider.META];

  return (
    <WhatsappProviderTemplateForm
      errors={errors}
      formState={formState}
      workspaceId={workspaceId}
      updateFormState={updateFormState}
      evolutionConfiguration={evolutionConfiguration}
    />
  );
}
